import { NavLink, useNavigate } from 'react-router-dom';
import { useState } from "react";
import { usePortfolio } from '../context/PortfolioProvider';
import Logo from "../assets/logo-heavy.svg";
import MenuIcon from "../assets/menu.svg";
import XIcon from "../assets/x.svg";
import MarketIcon from "../assets/chart-up.svg";
import MoneyIcon from "../assets/dollar-sign.svg";
import HistoryIcon from "../assets/history.svg";
import LogOutIcon from "../assets/log-out.svg";
import { formatPrice } from '../utils/formatUtils';
import api, { setAuthToken } from "../api/api";

export default function MainNav() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { portfolio } = usePortfolio();
  const navigate = useNavigate();

  const handleLogout = () => {
    setAuthToken(null);
    navigate('/');
  }

  return (
    <div className="bg-white sticky top-0 border-b shadow-sm z-50">
      <nav className="container flex justify-between items-center mx-auto p-4">
        <img src={Logo} alt="vitru-trade logo" className="w-9 h-9"/>
        <img src={isMobileMenuOpen ? XIcon : MenuIcon} alt="menu icon" onClick={() => setIsMobileMenuOpen(prev => !prev)} className="lg:hidden w-9 h-9"/>
        {/* Desktop nav links */}
        <div className="hidden lg:inline space-x-6">
          <NavLink to="/market" className={({ isActive }) => isActive ? "text-blue-500" : "hover:text-blue-500"}>Market</NavLink>
          <NavLink to="/portfolio" className={({ isActive }) => isActive ? "text-blue-500" : "hover:text-blue-500"}>Portfolio</NavLink>
          <NavLink to="/trade-history" className={({ isActive }) => isActive ? "text-blue-500" : "hover:text-blue-500"}>Trade History</NavLink>
          <button onClick={handleLogout} className="hover:text-blue-500">Log Out</button>
        </div>
      </nav>
      {/* Portfolio bar */}
      <div className="bg-blue-500 flex justify-center items-center gap-x-6 lg:gap-x-20 text-white text-sm lg:text-base mx-auto p-1 lg:p-2">
        {portfolio ? (
          <>
            <p>Portfolio: ${formatPrice(portfolio.total_portfolio_value)}</p>
            <p className="hidden lg:inline">Unrealized P/L: {portfolio.total_profit_loss >= 0 ? "+" : "-"}${Math.abs(portfolio.total_profit_loss).toFixed(2)} ({portfolio.total_return_percentage.toFixed(2)}%)</p>
            <p>Available Cash: ${formatPrice(portfolio.available_balance)}</p>
          </>
        ) : (
          <p>Loading portfolio data...</p>
        )}
      </div>
      {/* Mobile dropdown menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden w-full bg-white absolute top-full border-t shadow-md z-50">
          <div className="text-xl flex flex-col gap-y-4 p-4">
            <NavLink to="/market" onClick={() => setIsMobileMenuOpen(false)} className={({ isActive }) => `flex justify-start p-2 gap-x-2 ${isActive && "text-blue-500 font-semibold"}`}><img src={MarketIcon} alt="market icon" /> Market</NavLink>
            <NavLink to="/portfolio" onClick={() => setIsMobileMenuOpen(false)} className={({ isActive }) => `flex justify-start p-2 gap-x-2 ${isActive && "text-blue-500 font-semibold"}`}><img src={MoneyIcon} alt='portfolio icon' /> Portfolio</NavLink>
            <NavLink to="/trade-history" onClick={() => setIsMobileMenuOpen(false)} className={({ isActive }) => `flex justify-start p-2 gap-x-2 ${isActive && "text-blue-500 font-semibold"}`}><img src={HistoryIcon} alt='history icon' /> Trade History</NavLink>
            <button onClick={handleLogout} className="flex justify-start p-2 hover:bg-blue-50 gap-x-2"><img src={LogOutIcon} alt='log out icon' /> Log Out</button>
          </div>
        </div>
      )}
    </div>
  )
};